import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import styles from "./OnboardingPageTitle.module.scss";

const OnboardingPageTitle = ({ children, className, testId }) => (
  <Typography
    component="h2"
    className={`${styles.title} ${className || ""}`}
    data-testid={testId}
  >
    {children}
  </Typography>
);

OnboardingPageTitle.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  testId: PropTypes.string,
};

export default OnboardingPageTitle;
